import React from 'react';

const Reglamentos = () => {
    return (
        <div className='container fondotransparente p-5 my-5 '>
            <center><h1 className="p-5 botonbordeazul text-white px-5 mx-5 py-3">Leyes y Reglamentos</h1></center>
            <br />
            <p>Encontrá todas las Leyes y Reglamentos publicados en InProJuy.</p>
            <br /><br />

            <h3><strong>Leyes</strong></h3>
            <ul>
                <li className='h5 sinvineta'>
                    <a href="./download/LEY-DE-CREACION-DEL-INSTITUTO-DE-JUEGOS-DE-AZAR-DE-JUJUY.pdf" download>
                        LEY DE CREACIÓN DEL INSTITUTO DE JUEGOS DE AZAR DE JUJUY
                    </a>
                </li>
            </ul>
            <br />
            <hr className="wp-block-separator has-css-opacity" />
            <br />

            <h3><strong>Reglamentos de Juegos</strong></h3>
            <ul>
                <li className='h5 sinvineta'><a href="./download/reglamento-tombola.pdf" download >REGLAMENTO DE TÓMBOLA</a></li>
                <li className='h5 sinvineta'><a href="https://firebasestorage.googleapis.com/v0/b/inprojuy-f1173.appspot.com/o/descargas%2FReglamento%20Tombo%20Express.pdf?alt=media&token=b7658791-1413-4818-beee-f98b20df9169" download >REGLAMENTO TOMBO EXPRESS</a></li>
                <li className='h5 sinvineta'><a href="./download/BetWarrior.pdf" download >REGLAMENTO BETWARRIOR</a></li>
                <li className='h5 sinvineta'><a href="./download/reglamento-bingos-rifas-bonos.pdf" download >REGLAMENTO DE BINGOS, RIFAS, LOTAS, BONOS CONTRIBUCIÓN</a>
                    <a href="./download/R33-p-2024.pdf" download >, Resolución N° 033-P-2024</a>
                </li>
                <li className='h5 sinvineta'><a href="./download/Reglamento_de_Juego_OnLine.pdf" download >REGLAMENTO DE JUEGO ON LINE</a>
                    <a href="./download/R568-p-2023.pdf" download >, Resolución N° 568-P-2023</a>
                </li>
                <li className='h5 sinvineta'><a href="./download/Reglamento-TV-BINGO-BONAERENSE-TELEKINO-2023-1.pdf" download>REGLAMENTO TELEKINO</a></li>
                <li className='h5 sinvineta'><a href="./download/Reglamento_de_Salas_Tragamonedas.pdf" download>REGLAMENTO DE SALAS TRAGAMONEDAS</a>
                    <a href="./download/R296-p-2023.pdf" download >, Resolución N° 296-P-2023</a>
                </li>
                <li className='h5 sinvineta'>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/inprojuy-f1173.appspot.com/o/VLT.pdf?alt=media&token=b31e86bb-13ef-4576-8ac3-891b4f0f8ced"
                        download
                    >
                        REGLAMENTO VLT
                    </a>
                </li>
            </ul>
            <br />

            <h3><strong>Manuales y Procedimientos</strong></h3>
            <ul>
                <li className='h5 sinvineta'><a href="./download/MANUAL-PREVENCION-LAVADO-ACTIVOS.pdf" download>MANUAL DE PREVENCIÓN DE LAVADO DE ACTIVOS Y FINANCIAMIENTO DEL TERRORISMO</a></li>
                <li className='h5 sinvineta'><a href="./download/Procedimiento-Sorteos-Tombola-Inprojuy.pdf" download >MANUAL DE PROCEDIMIENTO DE SORTEO DE TÓMBOLA</a></li>
            </ul>
            <br />

            <h3><strong>Concursos</strong></h3>
            <ul>
                <li className='h5 sinvineta'>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/inprojuy-f1173.appspot.com/o/descargas%2FBases%20y%20Condicionesnuevo.pdf?alt=media&token=229ed67e-8fc6-4986-9692-b2615131f124"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Bases y Condiciones - Concurso de Decoración de Agencias y Subagencias
                    </a>
                </li>
            </ul>
            <br />

            <h3><strong>Requisitos y Buenas Prácticas</strong></h3>
            <ul>
                <li className='h5 sinvineta'><a href="./download/buenaspalea.pdf" download >Código de Buenas Prácticas para la Publicidad Responsable de Juegos de Azar Online en Argentina</a></li>
            </ul>
            <br />
        </div>
    )
}

export default Reglamentos;